var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('.app'),expression:"'.app'"}],staticClass:"scrollToTop__wrapper"},[_c('icon',{staticClass:"scrollToTop__icon",attrs:{"fill":"white","type":"angle-up"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bece866","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Search/SearchScrollToTop.vue
// module id = 721
// module chunks = 1